import { TranscriptionApi } from '../api/transcription'

export const {
  useGetTranscriptionQuery,
  useGetTranscriptionByConsultationQuery,
  useUpdateTranscriptionInfoMutation,
  useTranscribeFromFileMutation,
  useProposeStructuredDataMutation,
  useApplyStructuredDataMutation,
  useRecordTranscriptionConsentMutation,
  useRequestTranscriptionConsentMutation,
} = TranscriptionApi
